export default Object.freeze({
  UnSet: 0,
  Principal: 1,
  School: 135,
  ProviderOffice: 136,
  CSEE: 137,
  ToOtheServices: 478,
  ToTherapy: 479,
  ExtracurricularActivities: 480,
  SchoolSchoolSchedule: 481,
  Home: 482,
  ToSchoolHome: 483,
  HomeSchedule: 484,
  PrivateOffice: 485,
  Others: 486,
  Conversion: 489,
  CAAT: 490,
});
